import { render } from "./wechatLoginCheck.vue?vue&type=template&id=33ec502a"
import script from "./wechatLoginCheck.vue?vue&type=script&lang=js"
export * from "./wechatLoginCheck.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__